/**
 * 기념일 정보 클래스
 */
export class Anniversary {

  /**
   * 기념일 날짜
   */
  private $date: Date;

  /**
   * 기념일 이름
   */
  private $name: string = '';

  /**
   * 기념일 타입, class 이름에 추가됨
   */
  private $type: string = '';

  /**
   * 기념일 설명
   */
  private $desc: string = '';

  /**
   * @constructor
   */
  constructor(
    date: Date,
    name: string = '',
    type: string = '',
    desc: string = '') {
    this.$date = date;
    this.$name = name;
    this.$type = type;
    this.$desc = desc;
  }

  /** 기념일 날짜 */
  public get date(): Date {
    return this.$date;
  }

  /** 기념일 타입 */
  public get type(): string {
    return this.$type;
  }

  /** 기념일 이름 */
  public get name(): string {
    return this.$name;
  }

  /** 기념일 설명 */
  public get desc(): string {
    return this.$desc;
  }

  /** 기념일 이름 */
  public set name(name: string) {
    this.$name = name;
  }

  /**
   * 기념일의 날짜와 일치하는지 여부 반환
   */
  public equals(date: Date): boolean {
    return this.$date.getFullYear() === date.getFullYear() &&
      this.$date.getMonth() === date.getMonth() &&
      this.$date.getDate() === date.getDate();
  }
}
